import SoftBadge from "@/components/atoms/SoftBadge";
import PreformatifDiagnosticModal, {
  PreformatifDiagnosticModalMethods,
} from "@/components/molecules/modals/company/courses/PreformatifDiagnosticModal";
import CompanyCourse from "@/interfaces/CompanyCourse";
import { useGetPreformatifDiagnosticQuery } from "@/services/companies/courses/preformatifDiagnostic";
import { FC, useRef } from "react";
import { Button } from "react-bootstrap";

const CourseDiagnostic: FC<{
  companyId: string;
  course: CompanyCourse;
  onOpen: (courseId: string) => void;
}> = ({ companyId, course, onOpen }) => {
  const { data, isLoading } = useGetPreformatifDiagnosticQuery([
    companyId,
    course.id,
  ]);
  const name = course.course?.name ?? "Formation sans intitulé";
  const finalized = data?.status === "finalized";

  return (
    <li className="d-flex align-items-center justify-content-between gap-2 py-1">
      <span className="text-truncate">{name}</span>
      <span className="d-flex align-items-center gap-2 flex-shrink-0">
        {isLoading ? (
          <small className="text-600">Vérification du diagnostic…</small>
        ) : (
          <>
            <SoftBadge
              bg={finalized ? "success" : data ? "warning" : "secondary"}
            >
              {finalized
                ? "Diagnostic finalisé"
                : data
                  ? "Diagnostic en brouillon"
                  : "Diagnostic non commencé"}
            </SoftBadge>
            {!finalized && (
              <Button
                size="sm"
                variant="link"
                className="p-0"
                onClick={() => onOpen(course.id)}
                aria-label={`${data ? "Finaliser" : "Remplir"} le diagnostic de ${name}`}
              >
                {data ? "Finaliser" : "Remplir"} le diagnostic
              </Button>
            )}
          </>
        )}
      </span>
    </li>
  );
};

/**
 * État du diagnostic préformatif des formations liées à un rendez-vous montage,
 * qu'on complète sans quitter la fenêtre : un AE ne pose le rendez-vous qu'une
 * fois chacun finalisé (ADR 0012), ADMIN et CSM le voient pour information.
 */
const MontageDiagnosticChecklist: FC<{
  companyId: string;
  courses: readonly CompanyCourse[];
}> = ({ companyId, courses }) => {
  const modalRef = useRef<PreformatifDiagnosticModalMethods>(null);
  if (!courses.length) return null;

  return (
    <>
      <ul className="list-unstyled mb-0 mt-2 fs--1">
        {courses.map((course) => (
          <CourseDiagnostic
            key={course.id}
            companyId={companyId}
            course={course}
            onOpen={(courseId) => modalRef.current?.showOrHiddenModal(courseId)}
          />
        ))}
      </ul>
      <PreformatifDiagnosticModal ref={modalRef} companyId={companyId} />
    </>
  );
};

export default MontageDiagnosticChecklist;
